import * as React from 'react';
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridDataStateChangeEvent,
  GridToolbar,
  GridRowDoubleClickEvent,
  GridCustomFilterCellProps,
  isColumnMenuSortActive,
  isColumnMenuFilterActive,
} from '@progress/kendo-react-grid';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import {
  NodeInfo,
  NodeQueryResult,
  AssetInfo,
  GridRowAssetTableInfo,
} from '../../Interfaces/Assets/AssetInfo';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import './AssetsGridKendoCustomStyles.css';
import {
  getGroupIds,
  setExpandedState,
  setGroupIds,
  Pager,
  PageChangeEvent,
} from '@progress/kendo-react-data-tools';
import { DataResult, process, State } from '@progress/kendo-data-query';
import { saveNodesGridState } from '../../store/UserSettings/UserSettingsActions';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import {
  LocalizationProvider,
  loadMessages,
  load,
  IntlProvider,
} from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../AlertsGrid/GridLocale';
import { Button } from '@progress/kendo-react-buttons';
import {
  getLocalDateTime,
  flattenAssetData,
  exportAssetTableData,
} from '../../utils/utils';
import { LoadingPanel } from '../LoadingPanel';
import {
  exportFilteredAssets,
  getAllNodesByPage,
  resetNodesResult,
  resetFilteredAssets,
  resetFetchError,
  getAllNodes,
  reactivateNode,
  unregisterNode,
} from '../../store/Assets/AssetsActions';
import AssetsFilter from './AssetsFilter';
import NodeAssets from './NodeAssets';
import { FetchError } from '../../Interfaces/FetchError';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { CSVLink } from 'react-csv';
import { dateFormat } from '../../utils/utils';
import { initialAssetsDataState } from '../../store/UserSettings/UserSettingsState';
import Typography from '@material-ui/core/Typography';
import {
  Checkbox,
  createStyles,
  FormControlLabel,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { Splitter, SplitterOnChangeEvent } from '@progress/kendo-react-layout';
import StringResourceManager, { GetString } from '../StringResourceManager';
import esMessages from '../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');
import weekData from 'cldr-core/supplemental/weekData.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import caGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import numbers from 'cldr-numbers-full/main/fr/numbers.json';
import dateFields from 'cldr-dates-full/main/fr/dateFields.json';
import timeZones from 'cldr-dates-full/main/fr/timeZoneNames.json';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { CustomDateFilterCell } from '../CustomDateFilterCell';
import { RegistrationStatusCell } from './RegistrationStatusCell';
import { RegistrationStatusFilterCell } from './RegistrationStatusFilterCell';
import {
  ColumnMenu,
  CustomCell,
  CustomColumnMenu,
  HeaderCustomCell,
} from '../ColumnMenus/ColumnMenu';
import NodeActionButton from '../NodeActionButton';
import { ApiEnums } from '../../Interfaces/ApiEnums';

load(
  likelySubtags,
  currencyData,
  weekData,
  caGregorian,
  numbers,
  dateFields,
  timeZones
);
// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    laneCount: {
      fontWeight: 'bold',
    },
    bottomRight: {
      right: 0,
      bottom: 0,
      alignItems: 'flex-start',
      flexWrap: 'wrap-reverse',
    },
    error: {
      fontSize: '1.5rem',
    },
    container: {
      zIndex: 1,
      opacity: 1,
    },
    disabledContainer: {
      zIndex: 1,
      opacity: 0.1,
      pointerEvents: 'none',
    },
    nodeAssetsContainer: {
      zIndex: 2,
      position: 'absolute',
    },
  })
);

const DateTimeCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  if (
    dataItem?.LastHeartbeat &&
    dataItem.LastHeartbeat != '0001-01-01T00:00:00'
  ) {
    return (
      <td style={{ fontSize: '0.9rem' }}>
        {getLocalDateTime(dataItem.LastHeartbeat)}
      </td>
    );
  }
  return <td></td>;
};

interface ViewCommandCellProps extends GridCellProps {
  enterViewNodeAssets: (item: NodeInfo) => void;
}

const ViewCommandCell = (props: ViewCommandCellProps) => {
  if (props.dataIndex != -1)
    return (
      <td>
        <Button
          themeColor={'primary'}
          type="button"
          onClick={() => props.enterViewNodeAssets(props.dataItem)}
          style={{ fontSize: '0.9rem' }}
        >
          {GetString('VIEW')}
        </Button>
      </td>
    );
  else return null;
};

interface Props {
  setLastRefreshQuery: (lastRefreshDate: Date) => void;
}

enum ExportType {
  Assets,
  Table,
}

const FilterableNodesGrid: React.FC<Props> = ({
  setLastRefreshQuery,
}): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const status = GetString('STATUS');

  const csvLinkRef = React.useRef<
    CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }
  >(null);

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );
  const [includeDecommissioned, setIncludeDecommissioned] =
    React.useState(false);

  const loading: boolean = useSelector(
    (state: ApplicationState) => state.assetsReducer.isFetchingNodes
  );

  const nodeQueryResult: NodeQueryResult = useSelector(
    (state: ApplicationState) => state.assetsReducer.nodesByPage
  );

  const [selectedNodeAsset, setSelectedNodeAsset] =
    React.useState<NodeInfo>(Object);

  const [OpenNodeAssetsPage, setOpenNodeAssetsPage] =
    React.useState<boolean>(false);

  const [nodeQueryDynamicResult, setNodeQueryDynamicResult] =
    React.useState<any>(nodeQueryResult);

  const [exportType, setExportType] = React.useState<ExportType | undefined>(
    undefined
  );

  const nodesFilters: CompositeFilterDescriptor = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.nodesFilters
  );

  const [assetFilters, setAssetFilters] = React.useState<AssetInfo[]>([]);

  const COLUMN_TITLE_STORE = GetString('COLUMN_TITLE_STORE');
  const COLUMN_TITLE_CLUSTER = GetString('COLUMN_TITLE_CLUSTER');
  const COLUMN_TITLE_LANE = GetString('COLUMN_TITLE_LANE');
  const COLUMN_TITLE_DIVISION = GetString('COLUMN_TITLE_DIVISION');
  const COLUMN_TITLE_LANE_TYPE = GetString('COLUMN_TITLE_LANE_TYPE');
  const COLUMN_TITLE_LANE_ASSETS = GetString('COLUMN_TITLE_LANE_ASSETS');
  const COLUMN_TITLE_LANE_LAST_REFRESHED = GetString(
    'COLUMN_TITLE_LANE_LAST_REFRESHED'
  );
  const COLUMN_TITLE_MANAGEMENT_ACTION = GetString(
    'COLUMN_TITLE_MANAGEMENT_ACTION'
  );

  useEffect(() => {
    if (dataState !== undefined) {
      setDataResult(
        processWithGroups(nodeQueryDynamicResult.Result, dataState)
      );
    }
    return () => {};
  }, []);

  useEffect(() => {
    setNodeQueryDynamicResult(nodeQueryResult);
  }, [nodeQueryResult.Result]);

  useEffect(() => {
    processDynamicNodeInfoResult();
  }, [nodeQueryDynamicResult.Result]);

  const processAssetFilterInfo = () => {
    let assetFilters: AssetInfo[] = [];
    nodesFilters.filters?.map((x: any) => {
      if (x?.field && x.field == 'AssetInfo') {
        let assetFilterInfo: AssetInfo = x?.value;
        if (
          assetFilterInfo?.Category != null &&
          assetFilterInfo?.Category != undefined &&
          assetFilterInfo?.Name != null &&
          assetFilterInfo?.Name != undefined
        ) {
          let filterExist = assetFilters.findIndex(
            (info: AssetInfo) =>
              info.Category == assetFilterInfo?.Category &&
              info.Name == assetFilterInfo?.Name
          );
          if (filterExist == -1) assetFilters.push(x?.value);
        }
      }
    });
    setAssetFilters(assetFilters);
  };

  const processDynamicNodeInfoResult = () => {
    processAssetFilterInfo();
    let nodeInfoList: any = nodeQueryDynamicResult.Result;
    if (nodeInfoList.length > 0 && assetFilters.length > 0) {
      for (let i = 0; i < nodeInfoList.length; i++) {
        for (let s = 0; s < assetFilters.length; s++) {
          nodeInfoList[i][assetFilters[s].Category + assetFilters[s].Name] =
            nodeInfoList[i].AssetInfoList.find(
              (asset: AssetInfo) =>
                asset.Category == assetFilters[s].Category &&
                asset.Name == assetFilters[s].Name
            )?.Value;
        }
      }
    }
    setDataResult(processWithGroups(nodeInfoList, dataState));
  };

  const processWithGroups = (data: any[], dataState: State): DataResult => {
    if (dataState === undefined) {
      dataState = initialAssetsDataState;
    }

    let filter: (FilterDescriptor | CompositeFilterDescriptor)[] = [];

    let subFilter: FilterDescriptor[] = [];

    const filters:
      | (CompositeFilterDescriptor | FilterDescriptor)[]
      | undefined = dataState.filter?.filters;

    filters?.map((x: any) => {
      const props = new Map<string, FilterDescriptor[]>(Object.entries(x));
      const newFilters: FilterDescriptor[] = props.get('filters') || [];
      const nodeTypeFilterDescriptor: FilterDescriptor[] = [];
      const nodeTypeFilter: CompositeFilterDescriptor = {
        logic: 'or',
        filters: nodeTypeFilterDescriptor,
      };

      newFilters.map(a => {
        if (Array.isArray(a.value)) {
          for (let i = 0; i < a.value.length; i++) {
            const newValue: FilterDescriptor = {
              field: a?.field,
              operator: a?.operator,
              value: a?.value[i],
            };
            nodeTypeFilterDescriptor.push(newValue);
          }
        }
      });

      if (x.field === 'ManagementAction' || x.field === 'LastHeartbeat') {
        filter.push(x);
      } else {
        newFilters.map(a => {
          if (Array.isArray(a.value)) {
            filter.push(nodeTypeFilter);
          } else filter.push(x);
        });
      }
    });

    const newFilter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: filter,
    };

    if (subFilter.length > 0)
      newFilter.filters.push({
        logic: 'or',
        filters: subFilter,
      });

    const newDataStateValue: State = {
      ...dataState,
      filter: newFilter,
    };

    const newDataState: DataResult = process(data, newDataStateValue);

    setGroupIds({ data: newDataState.data, group: newDataStateValue.group });

    return newDataState;
  };

  const dataState: State = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.nodesGridDataState
  );

  const filteredAssetsData: NodeInfo[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.filteredAssetsData
  );

  const fetchError: FetchError = useSelector(
    (state: ApplicationState) => state.assetsReducer.fetchError
  );

  const [uniqueKeyOnRefresh, setUniqueKeyOnRefresh] = React.useState<Date>(
    new Date()
  );

  const [dataResult, setDataResult] = React.useState<DataResult>(
    processWithGroups(nodeQueryDynamicResult.Result, dataState)
  );

  const dataStateChange = (event: GridDataStateChangeEvent) => {
    saveNodesGridState(dispatch, event.dataState);
    setDataResult(
      processWithGroups(nodeQueryDynamicResult.Result, event.dataState)
    );
  };

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  const [collapsedState, setCollapsedState] = React.useState<string[]>([]);

  const onGroupsToggle = React.useCallback(() => {
    const dataStateWithoutPaging = processWithGroups(
      nodeQueryDynamicResult.Result,
      {
        group: dataState.group,
      }
    );

    setCollapsedState(
      collapsedState.length
        ? []
        : getGroupIds({ data: dataStateWithoutPaging.data })
    );
  }, [collapsedState, dataState]);

  const newData = setExpandedState({
    data: dataResult.data,
    collapsedIds: collapsedState,
  });

  const onRunFilterNodesQuery = () => {
    let newDataState: State = {
      skip: 0,
      take: dataState.take,
      sort: dataState.sort,
      group: dataState.group,
    };

    saveNodesGridState(dispatch, newDataState);

    if (nodeQueryDynamicResult.Result.length > 0) {
      resetNodesResult(dispatch);
    }
    setLastRefreshQuery(new Date());
    setUniqueKeyOnRefresh(new Date());
    getAllNodesByPage(dispatch, includeDecommissioned);
  };

  const handleIncludeDecommissionedRecords = () => {
    setIncludeDecommissioned(prevState => {
      const newState = !prevState;
      getAllNodes(dispatch, newState);
      return newState;
    });
  };

  const rowDoubleClick = (event: GridRowDoubleClickEvent) => {
    if (event.dataItem.NodeID !== undefined)
      enterViewNodeAssets(event.dataItem);
  };

  const enterViewNodeAssets = (data: NodeInfo) => {
    setSelectedNodeAsset(data);
    setOpenNodeAssetsPage(true);
  };

  const MyViewCommandCell = (props: GridCellProps) => (
    <ViewCommandCell {...props} enterViewNodeAssets={enterViewNodeAssets} />
  );

  const [assetsDataToExport, setAssetDataToExport] = React.useState<
    GridRowAssetTableInfo[]
  >([]);

  useEffect(() => {
    if (filteredAssetsData.length > 0) {
      if (exportType === ExportType.Assets) setAssetsDataToExport();
      else if (exportType === ExportType.Table) setAssetsTableToExport();
    }

    setExportType(undefined);
  }, [filteredAssetsData]);

  const setAssetsDataToExport = async () => {
    let gridRowAssetDataArray: GridRowAssetTableInfo[] =
      flattenAssetData(filteredAssetsData);
    setAssetDataToExport(gridRowAssetDataArray);
  };

  const setAssetsTableToExport = async () => {
    let tableDataArray = exportAssetTableData(filteredAssetsData, assetFilters);
    setAssetDataToExport(tableDataArray);
  };

  useEffect(() => {
    if (assetsDataToExport.length > 0 && csvLinkRef?.current) {
      csvLinkRef.current.link.click();

      resetFilteredAssets(dispatch);
    }
  }, [assetsDataToExport]);

  const getCSVFileName = () => {
    return `assets_export_${dateFormat(currentLocale.language)}`;
  };

  const downloadAssetsData = async () => {
    setExportType(ExportType.Assets);
    exportFilteredAssets(dispatch);
  };

  const exportTableData = () => {
    setExportType(ExportType.Table);
    exportFilteredAssets(dispatch);
  };

  const [verticalPanes, setVerticalPanes] = React.useState<Array<any>>([
    {},
    {},
  ]);

  const onVerticalChange = (event: SplitterOnChangeEvent) => {
    setVerticalPanes(event.newState);
  };

  const handlePageChange = (event: PageChangeEvent) => {
    let newDataState: State = {
      skip: event.skip,
      take: event.take,
      sort: dataState.sort,
      group: dataState.group,
    };

    saveNodesGridState(dispatch, newDataState);

    if (event.skip >= nodeQueryDynamicResult.Result.length) {
      getAllNodesByPage(dispatch, includeDecommissioned);
    }
  };

  useEffect(() => {
    if (nodeQueryDynamicResult?.Result) {
      setDataResult(
        processWithGroups(nodeQueryDynamicResult.Result, dataState)
      );
    }
  }, [nodeQueryDynamicResult, dataState]);

  useEffect(() => {
    let timeoutId: any;
    if (fetchError.StatusCode > 0 && fetchError.Message != '') {
      displayError(true);
      timeoutId = setTimeout(() => {
        clearFetchError();
      }, 3000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [fetchError]);

  const [error, displayError] = React.useState(false);

  const clearFetchError = () => {
    displayError(false);
    resetFetchError(dispatch);
  };

  useEffect(() => {
    resetNodesResult(dispatch);
    getAllNodesByPage(dispatch, includeDecommissioned);
  }, []);

  const handleButtonClick = (
    actionType: ApiEnums.ManagementActions,
    uuid: string
  ) => {
    if (actionType === ApiEnums.ManagementActions.Active) {
      unregisterNode(dispatch, uuid).then(() =>
        getAllNodes(dispatch, includeDecommissioned)
      );
    } else if (actionType === ApiEnums.ManagementActions.Decommissioned) {
      reactivateNode(dispatch, uuid).then(() =>
        getAllNodes(dispatch, includeDecommissioned)
      );
    }
  };

  const NodesActionsCellWrapper = (props: GridCellProps) => {
    const dataItem = props.dataItem;
    if (dataItem?.NodeID) {
      return (
        <td>
          <NodeActionButton
            node={dataItem}
            handleActionButtonClick={handleButtonClick}
          />
        </td>
      );
    }
    return null;
  };

  const pager = () => {
    return (
      <Pager
        skip={dataState.skip as number}
        take={dataState.take as number}
        total={nodeQueryResult.TotalRows}
        onPageChange={handlePageChange}
        buttonCount={10}
        info={true}
        previousNext={true}
        type="numeric"
        pageSizes={[10, 50, 100, 500, 1000]}
      />
    );
  };

  const dateFilterCell = (props: GridCustomFilterCellProps) => {
    return (
      <CustomDateFilterCell
        gridFilterCellProps={props}
        dataState={dataState}
        fieldName="LastHeartbeat"
      />
    );
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };

  const isColumnActive = (field: string, dataState: State) => {
    return (
      isColumnMenuFilterActive(field, dataState.filter) ||
      isColumnMenuSortActive(field, dataState.sort)
    );
  };

  return (
    <div>
      <div hidden={!OpenNodeAssetsPage} className={classes.nodeAssetsContainer}>
        <NodeAssets
          isPageOpened={OpenNodeAssetsPage}
          handleClosePage={() => setOpenNodeAssetsPage(false)}
          assetData={selectedNodeAsset}
        />
      </div>
      <div
        className={
          OpenNodeAssetsPage ? classes.disabledContainer : classes.container
        }
      >
        <LocalizationProvider language={currentLocale.language}>
          <IntlProvider locale={currentLocale.locale}>
            <CSVLink
              data={assetsDataToExport}
              ref={csvLinkRef}
              filename={getCSVFileName() + '.csv'}
            />
            <Splitter
              panes={verticalPanes}
              orientation={'vertical'}
              onChange={onVerticalChange}
            >
              <div>
                <AssetsFilter />
              </div>
              <div>
                {loading && LoadingPanel}
                <Grid
                  key={`${uniqueKeyOnRefresh}`}
                  style={{ height: '73vh' }}
                  sortable={true}
                  filterable={true}
                  groupable={true}
                  reorderable={true}
                  resizable={true}
                  pageable={true}
                  fixedScroll={false}
                  pager={pager}
                  data={dataResult}
                  {...dataState}
                  onDataStateChange={dataStateChange}
                  onRowDoubleClick={rowDoubleClick}
                  cells={{
                    headerCell: HeaderCustomCell,
                    data: CustomCell,
                  }}
                >
                  <GridToolbar>
                    <Button onClick={onRunFilterNodesQuery}>
                      <StringResourceManager stringKey="RUN_QUERY" />
                    </Button>
                    <Button onClick={onGroupsToggle}>
                      <StringResourceManager
                        stringKey={
                          collapsedState.length
                            ? 'EXPAND_GROUPS'
                            : 'COLLAPSE_GROUPS'
                        }
                      />
                    </Button>
                    <Button onClick={downloadAssetsData}>
                      <StringResourceManager stringKey="EXPORT_ASSETS_TO_CSV" />
                    </Button>
                    <Button onClick={exportTableData}>
                      <StringResourceManager stringKey="EXPORT_TABLE_TO_CSV" />
                    </Button>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={handleIncludeDecommissionedRecords}
                          name="includeDecommissioned"
                          color="primary"
                          checked={includeDecommissioned}
                        />
                      }
                      label={GetString('INCLUDE_DECOMMISSIONED_RECORDS')}
                    />
                  </GridToolbar>
                  <GridToolbar>
                    <StringResourceManager
                      stringKey="LANE_COUNT"
                      variant="body1"
                    />
                    <Typography variant="body1" className={classes.laneCount}>
                      {nodeQueryResult.TotalRows}
                    </Typography>
                  </GridToolbar>
                  <GridColumn
                    {...columnProps('Division')}
                    title={COLUMN_TITLE_DIVISION}
                    width="130px"
                    columnMenu={ColumnMenu}
                    filterable={false}
                  />
                  <GridColumn
                    {...columnProps('SiteNumber')}
                    field="SiteNumber"
                    title={COLUMN_TITLE_STORE}
                    width="110px"
                    columnMenu={ColumnMenu}
                    filterable={false}
                  />
                  <GridColumn
                    {...columnProps('NodeGroup')}
                    title={COLUMN_TITLE_CLUSTER}
                    width="110px"
                    filterable={false}
                    columnMenu={ColumnMenu}
                  />
                  <GridColumn
                    {...columnProps('LaneNumber')}
                    title={COLUMN_TITLE_LANE}
                    width="110px"
                    columnMenu={ColumnMenu}
                    filterable={false}
                  />
                  <GridColumn
                    {...columnProps('NodeType')}
                    title={COLUMN_TITLE_LANE_TYPE}
                    columnMenu={props => (
                      <CustomColumnMenu {...props} dataState={dataState} />
                    )}
                    width="130px"
                    filterable={false}
                  />
                  {assetFilters.map((assetInfo: AssetInfo) => (
                    <GridColumn
                      key={assetInfo.Category + assetInfo.Name}
                      {...columnProps(assetInfo.Category + assetInfo.Name)}
                      title={assetInfo.Category + ' ' + assetInfo.Name}
                      width="240px"
                      columnMenu={ColumnMenu}
                      filterable={false}
                    />
                  ))}
                  <GridColumn
                    {...columnProps('viewAssets')}
                    cells={{ data: MyViewCommandCell }}
                    title={COLUMN_TITLE_LANE_ASSETS}
                    width="90px"
                    filterable={false}
                  />
                  <GridColumn
                    field="ManagementAction"
                    title={COLUMN_TITLE_MANAGEMENT_ACTION}
                    width="200px"
                    cells={{
                      data: RegistrationStatusCell,
                      filterCell: RegistrationStatusFilterCell,
                    }}
                  />
                  <GridColumn
                    field="LastHeartbeat"
                    title={COLUMN_TITLE_LANE_LAST_REFRESHED}
                    cells={{ data: DateTimeCell, filterCell: dateFilterCell }}
                    width="250px"
                  />
                  <GridColumn
                    field="Actions"
                    title={GetString('COLUMN_TITLE_ACTIONS')}
                    width="180px"
                    filterable={false}
                    cells={{ data: NodesActionsCellWrapper }}
                  />
                </Grid>
                <Fade>
                  <NotificationGroup className={classes.bottomRight}>
                    {error && (
                      <Notification
                        className={classes.error}
                        type={{
                          style: 'error',
                          icon: true,
                        }}
                        closable={true}
                        onClose={() => clearFetchError()}
                      >
                        <StringResourceManager stringKey={fetchError.Message} />
                        {`(${status}: ${fetchError.StatusCode})`}
                      </Notification>
                    )}
                  </NotificationGroup>
                </Fade>
              </div>
            </Splitter>
          </IntlProvider>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default FilterableNodesGrid;
